import React, { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import { navigate } from "gatsby";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";

const ButtonData = {
  option1: {
    option1: "A Debt Relief Program to reduce my debt without a new loan.",
    option2: "A Debt Consolidation Loan.",
    option3: "I’m not sure, but I need to get out of debt.",
  },
  option2: {
    option1: "Yes",
    option2: "No",
  },
};

const Steps = ({ name }) => {
  const [debtValue, setDebtValue] = useState(35000);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [formError, setFormError] = useState({
    option1: "",
    option2: "",
    option3: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [values, setValues] = useState({
    option1: "",
    option2: "",
    option3: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const handleSliderChange = (sliderEvent, newSliderValue) => {
    setDebtValue(newSliderValue);
    setValues({
      ...values,
      option3: newSliderValue ? newSliderValue : 35000,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);

    const url = window.location.href;
    const emailData = {
      subject: `Referer: [${url}]`,
      fromName: `ADC ${name} Referer: ${url}`,
      googleUrlParameter: url,
      toName: "there",
      referer: url,
      ...values,
    };

    emailjs
      .send(
        "service_p5cs97s",
        "template_gkcc099",
        emailData,
        "PvTyuGGKn4qTGC0S7"
      )
      .then(
        (result) => {
          setStep("redirect");
          setLoading(false);
          setValues({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            message: "",
            option1: "",
            option2: "",
            option3: "",
          });

          setTimeout(() => {
            navigate("/next-step/");
          }, 750);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      );
  };

  const handleBeforeUnload = (e) => {
    // Check if any of the input fields are filled
    if (values.option1 !== "") {
      e.preventDefault();
      e.returnValue = ""; // Required for Chrome
      // setShowAlert(true);
      // Show your custom alert modal here
      // ...
    } else {
      // setShowAlert(false);
    }
  };

  useEffect(() => {
    if (values.option1 && values.option2 !== "No") {
      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
    // eslint-disable-next-line
  }, [values]);

  useEffect(() => {
    if (values.option2 === "No") {
      navigate("/loans/");
      setStep("redirect");
    }
  }, [values]);

  return (
    <div className="bg-white py-16" id="debtFree">
      <div className="mx-auto lg:w-3/5 px-4">
        <div className="mx-auto max-w-6xl py-18">
          <div className="flex flex-col justify-center items-center w-full">
            {step === 1 ? (
              <Step1
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                setFormError={setFormError}
                ButtonData={ButtonData}
                formError={formError}
                setStep={setStep}
                values={values}
                step={step}
              />
            ) : step === 2 ? (
              <Step2
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                setFormError={setFormError}
                ButtonData={ButtonData}
                formError={formError}
                setStep={setStep}
                values={values}
                step={step}
              />
            ) : step === 3 ? (
              <Step3
                handleSliderChange={handleSliderChange}
                handleSubmit={handleSubmit}
                setFormError={setFormError}
                debtValue={debtValue}
                formError={formError}
                setStep={setStep}
                values={values}
                step={step}
              />
            ) : step === 4 ? (
              <Step4
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                formError={formError}
                loading={loading}
                values={values}
              />
            ) : step === "redirect" ? (
              <div className="text-center">
                <p className="text-md text-gray-700 font-bold">
                  Redirecting you shortly...
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;
